"use client";

import { updateEcommerceState } from "@/service/ecommerce";
import { triggerSelectItem } from "@/service/ecommerce/google-analytics/single-item";
import { createPath } from "@/service/routing/routing";
import { useRouter } from "@bprogress/next";
import { SuperLink as Link } from "@/components/common/super-link";
import { trans } from "@/service/i18n/i18n";
import { useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";
import { clientPost } from "@/service/client-api/client-api";
import { Button, ButtonVariant } from "@/components/ui/button";
import { ShoppingCartIcon } from "lucide-react";

export const BuyButton = ({
  product,
  text = "Dodaj do koszyka",
  name = "",
  category = "",
  type = "default",
  instantMoveToCart = false,
  buyAsVoucher = false,
  variant = "secondary",
}: {
  product: ProductPriceOneVariantVM;
  text?: string;
  name?: string;
  category?: string;
  type?: string;
  instantMoveToCart?: boolean;
  buyAsVoucher?: boolean;
  variant?: ButtonVariant;
}) => {
  const router = useRouter();
  const { price, id, promotionPrice } = product ?? {};
  const { logView } = useContext(ResourceContext);

  if (!product) {
    return <></>;
  }

  async function onClick() {
    if (product.inCart) return;

    const promise = updateEcommerceState("add", { price, id, type });

    await promise;

    if (buyAsVoucher) {
      try {
        await clientPost("ecommerce.set_order_to_voucher");
      } catch (error) {
        console.error(error);
      }
    }

    triggerSelectItem(
      {
        name,
        id,
        price: parseFloat(price),
        promotionPrice: promotionPrice ? parseFloat(promotionPrice) : null,
        category,
      },
      logView,
    );
    if (instantMoveToCart) {
      router.push(createPath("ecommerce"));
    } else {
      const event = new CustomEvent("cart-state");
      document.dispatchEvent(event);
      router.refresh();
    }
  }

  const inCart = product.inCart;

  if (inCart) {
    return (
      <Button variant={variant} asChild className="w-full">
        <Link href={createPath("ecommerce")}>
          {trans("ecommerce.go_to_cart")}
        </Link>
      </Button>
    );
  }

  return (
    <Button variant={variant} onClick={onClick} className="w-full">
      <ShoppingCartIcon /> {text}
    </Button>
  );
};
